<template>
  <div class="contents">
    <div v-for="(option, i) of optionsValue" :key="i" class="content">
      <el-input
        v-model="option.name"
        @input="$emit('input', optionsValue)"
        type="text"
        :placeholder="'Название опции'"
        class="mt10"
      />
      <el-select
        v-model="option.availability"
        :multiple="false"
        :value-key="'code'"
        filterable
        clearable
        style="width: 100%"
        class="mt10"
        placeholder="Доступность опции"
      >
        <el-option
          v-for="(option, optionName, index) in select"
          :key="index"
          :label="option.label"
          :value="option.code"
          :readonly="true"
        />
      </el-select>
      <el-input
        v-model="option.priority"
        @input="$emit('input', optionsValue)"
        type="number"
        :placeholder="'Приоритет'"
        class="mt10"
      />
    </div>
    <el-button
      type="primary"
      size="mini"
      @click="optionsValue.push(Object.assign({}, templateContent))"
    >
      +
    </el-button>
    <el-button
      v-if="optionsValue.length > 1"
      type="danger"
      size="mini"
      @click="optionsValue.pop()"
    >
      -
    </el-button>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      select: [
        {
          code: "available",
          label: "Доступна",
        },
        {
          code: "not_available",
          label: "Недоступна",
        },
        {
          code: "in_tarrif",
          label: "Включена в тариф",
        },
      ],
      contents: [
        // {
        //   availability: "",
        //   name: "",
        //   priority: undefined,
        // },
      ],
      templateContent: {
        availability: "",
        name: "",
        priority: null,
      },
    };
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal == undefined && oldVal) {
        this.clearFields();
      }
    },
  },
  computed: {
    optionsValue: {
      get() {
        return this.value || this.contents;
      },
    },
  },
  methods: {
    clearFields() {
      this.contents = [
        // {
        //   availability: "",
        //   name: "",
        //   priority: undefined,
        // },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.mt10 {
  margin-top: 10px;
}
.contents {
  & .step:last-child {
    margin-bottom: 0;
  }

  #not-require {
    border: 1px solid #dcdfe6 !important;
  }
}
.content {
  border: 1px solid #dcdfe6;
  margin-bottom: 15px;
  border-radius: 4px;
  padding: 0 10px 10px 10px;
}
</style>

<style>
.el-form-item.is-error #not-require {
  border: 1px solid #dcdfe6 !important;
}
</style>
